import { Message } from "element-ui";

//模版json
export const templateJSON = {
  panels: [
    {
      index: 0,
      height: 99,
      width: 100,
      paperHeader: 0,
      paperFooter: 130,
      printElements: [
        //内容
        {
          options: {
            width: 80,
            height: 30,
            top: 0,
            left: 0,
            title: "hiprint插件手动添加text", //标题或内容，field 存在：title为标题，打印结果为 title:data , field 不存在：title为内容，打印结果为 title
            // field:'',// 字段名称  html 动态替换字段
            fontSize: "20", //字体大小
            fontWeight: "normal", //字体粗细
            color: "#000", //字体颜色
            lineHeight: 20, //字体大小
            textType: "text", //文本类型 text barcode(条形码) qrcode(二维码)
            textAlign: "left",
            hideTitle: false, //隐藏标题
            transform: "0", //旋转角度
          },
          printElementType: {
            //类型 必填
            title: "文本",
            type: "text",
          },
        },
      ],
      paperNumberDisabled: true, //禁用页脚 1-1
      rotate: true,
    },
  ],
};

//批量打印多条带数据格式的条形码
export const printJSON = {
  panels: [
    {
      index: 0,
      height: 60,
      width: 100,
      printElements: [
        {
          options: {
            left: 5,
            top: 5,
            height: 23,
            width: 72,
            field: "barcode",
            testData: "1234556",
            textType: "barcode",
          },
          printElementType: { title: "文本", type: "text" },
        },
        {
          options: {
            left: 5,
            top: 40,
            height: 13,
            width: 93,
            field: "name",
            hideTitle: "1",
            testData: "123",
          },
          printElementType: { title: "文本", type: "text" },
        },
      ],
      paperNumberDisabled: true,
      // rotate: true,
    },
  ],
};
export const createB = function () {
  let barCodehiprintTemplate = new hiprint.PrintTemplate({
    template: printJSON,
  });

  barCodehiprintTemplate.design("#templateDesignDiv");

  //打印
  var $html = barCodehiprintTemplate.getHtml([
    {
      barcode: "13234567",
    },
  ]);
  barCodehiprintTemplate.printByHtml($html);
};

//处理 长文本添加参数
//解决字段超出区域的问题
export const hanlePrintElementsStyle = function (list) {
  list.forEach((item) => {
    if (item.printElementType.title == "长文") {
      item.options.styler = function () {
        return {
          overflow: "hidden",
        };
      };
    }
  });
  return list;
};

//打印动态字段
/*
 *
 *hiprintTemplate 打印实例
 *
 *  arr 数组打印张数 内部对象为对应字段的值   [{name:'xx'}]
 * 打印前需要hanlePrintElementsStyle 处理json
 */
export const printHtml = function (hiprintTemplate, arr) {
  //打印
  var $html = hiprintTemplate.getHtml(arr);
  hiprintTemplate.printByHtml($html);
};

//打印
export const print = function (json, arr = [{}]) {
  try {
    json.panels[0].printElements = hanlePrintElementsStyle(
      json.panels[0].printElements
    );
  } catch {
    Message.warning("打印有误！");
    return;
  }
  let hiprintTemplate = new hiprint.PrintTemplate({
    template: json,
  });
  printHtml(hiprintTemplate, arr);
};

//转pdf
export const print2 = function (json, arr = [{}]) {
  console.log("print2print2print2print2print2print2print2print2print2print2");
  console.log(json);
  try {
    json.panels[0].printElements = hanlePrintElementsStyle(
      json.panels[0].printElements
    );
  } catch {
    Message.warning("打印有误！");
    return;
  }
  let hiprintTemplate = new hiprint.PrintTemplate({
    template: json,
  });

  var $html = hiprintTemplate.getHtml(arr);
  console.log($html);
  hiprintTemplate.printByHtml2($html);
};

//转html
export const toHtml = function (json, item = {}) {
  try {
    json.panels[0].printElements = hanlePrintElementsStyle(
      json.panels[0].printElements
    );
  } catch {
    Message.warning("打印有误！");
    return;
  }
  let hiprintTemplate = new hiprint.PrintTemplate({
    template: json,
  });
  return getHtml(hiprintTemplate, item);
};
//获取画板 html片段
export const getHtml = function (hiprintTemplate, optionsObj) {
  let json = hiprintTemplate.getHtml(optionsObj)[0].outerHTML;
  return json;
};

export async function renderAndPrint(pdfUrl) {  
  const pdf = await pdfjsLib.getDocument(pdfUrl).promise;
  const totalPages = pdf.numPages;

  // 创建临时画布计算总尺寸
  const tempPage = await pdf.getPage(1);
  const tempViewport = tempPage.getViewport({ scale: 1 });
  const pageWidth = tempViewport.width;
  const pageHeight = tempViewport.height;
  tempPage.cleanup();

  // 创建超大画布
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  canvas.width = pageWidth;
  canvas.height = pageHeight * totalPages; // 纵向排列所有页

  // 分页渲染到同一画布
  let currentY = 0;
  for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
    const page = await pdf.getPage(pageNum);
    const viewport = page.getViewport({ scale: 1 });
    
    // 调整坐标系定位
    context.save();
    context.translate(0, currentY);
    
    await page.render({
      canvasContext: context,
      viewport: viewport
    }).promise;
    
    context.restore();
    currentY += pageHeight;
    page.cleanup(); // 释放内存
  }

  // 生成最终图片
  const finalImage = new Image();
  finalImage.src = canvas.toDataURL('image/jpeg', 0.8); // 压缩质量

  // 打印优化
  finalImage.onload = () => {
    const printWindow = window.open('');
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <style>
            @media print {
              img{
              }
            }
              img {
                display:block;-webkit-user-select: none;margin: auto;
                // width: 100% !important;
                // height: auto !important;
                // page-break-inside: avoid !important;
              }
          </style>
        </head>
        <body>
          <img src="${finalImage.src}" 
               style="max-width:100%;height:auto;">
        </body>
      </html>
    `);

    // 智能延迟打印
    const tryPrint = () => {
      printWindow.print();
    }
    setTimeout(tryPrint, 1000);
  };
}